import { render, staticRenderFns } from "./MasterDiscountCodeOrders.vue?vue&type=template&id=13c34d65"
import script from "./MasterDiscountCodeOrders.vue?vue&type=script&lang=js"
export * from "./MasterDiscountCodeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports